import {
  headline,
  text,
  survey,
  button,
  spacer,
  rank,
  voucher,
} from '@components/Widgets/_contentItems/all'
import { settings, styling } from '@components/Widgets/Templates/Base/_base'
import themes from '@components/Widgets/Templates/Themes/all'
import { position, type, maxWidth, ribbonType, trigger } from '@meta/widget/options.js'
import { typeTag, tag } from '@meta/widget/templates.js'

const info = {
  name: 'Shopping Quiz',
  templateID: '13',
  description:
    'Engage your audience with the "Shopping Quiz" widget. This interactive quiz helps you understand your customers\' shopping preferences while capturing valuable lead information.',
  tags: [typeTag.FLYOUT, tag.LEAD_GENERATION],
}

const json = {
  id: 45001302,
  templateID: info.templateID,
  type: type.COLUMN,
  name: info.name,
  active: true,
  theme: themes.BLACK_FRIDAY.theme,
  settings: (() => {
    const customSettings = { ...settings }
    customSettings.position = position.CENTER
    customSettings.ribbonColor = '#FEFEFE'
    customSettings.ribbonBgColor = '#1E1E1E'
    customSettings.animation = 'slide'
    customSettings.trigger = trigger.RIBBON
    customSettings.triggerSeconds = 2
    customSettings.ribbonText = 'Exclusive Deal'
    customSettings.ribbonType = ribbonType.TEXT
    customSettings.closeButton = true
    return customSettings
  })(),
  styling: (() => {
    const customStyling = { ...styling }
    customStyling.maxWidth = maxWidth.LARGE
    customStyling.borderRadius = '40px'
    customStyling.backgroundColor = '#1E1E1E'
    return customStyling
  })(),
  steps: [
    {
      id: 'bfq1',
      contentItems: [
        // (() => {
        //   const customImage = JSON.parse(JSON.stringify(image))
        //   customImage.content.url = 'https://assets.onvocado.com/templates/black_friday-tag_white-small.png'
        //   Object.assign(customImage.styling, {
        //     backgroundColor: 'rgba(0, 0, 0, 0)',
        //     backgroundSize: 'cover',
        //     backgroundPosition: 'center',
        //   })
        //   return customImage
        // })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Promo Shopping Quiz'
          Object.assign(customHeadline.styling, {
            color: '#FFFFFF',
            fontSize: '40px',
            fontFamily: 'Anton',
            fontWeight: 'bold',
            textAlign: 'center',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>Discover the best deals tailored just for you! Let&#39;s get started.</p>'
          Object.assign(customText.styling, {
            color: '#FFFFFF',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '20px'
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Start Quiz'
          Object.assign(customButton.styling, {
            color: '#FFFFFF',
            fontSize: '20px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            borderColor: 'rgba(133, 0, 27, 1)',
            borderWidth: '0',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgba(133, 0, 27, 1)',
            padding: '10px 20px',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: 'bfq2',
      contentItems: [
        // (() => {
        //   const customImage = JSON.parse(JSON.stringify(image))
        //   customImage.content.url = 'https://assets.onvocado.com/templates/black_friday-tag_white-small.png'
        //   Object.assign(customImage.styling, {
        //     backgroundColor: 'rgba(0, 0, 0, 0)',
        //     backgroundSize: 'cover',
        //     backgroundPosition: 'center',
        //   })
        //   return customImage
        // })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'What is your favorite category to shop?'
          Object.assign(customHeadline.styling, {
            color: '#FFFFFF',
            fontSize: '24px',
            fontFamily: 'Anton',
            fontWeight: 'bold',
            textAlign: 'left',
          })
          return customHeadline
        })(),
        (() => {
          const customSurvey = JSON.parse(JSON.stringify(survey))
          customSurvey.content.options = [
            { id: 'k5rj2hy', text: 'Electronics' },
            { id: '9sheias', text: 'Clothing' },
            { id: '9sheias', text: 'Home Appliances' },
            { id: '9sheias', text: 'Beauty Products' },
          ]
          Object.assign(customSurvey.styling, {
            color: 'rgb(0, 0, 0)',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Anton',
            fontWeight: '400',
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: '0px',
            borderRadius: '20px',
            backgroundColor: 'rgb(254,254,254)',
          })
          customSurvey.settings.label = 'Favorite Category'
          customSurvey.settings.required = true
          return customSurvey
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '15px'
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Next'
          Object.assign(customButton.styling, {
            color: '#FFFFFF',
            fontSize: '20px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            borderColor: 'rgba(133, 0, 27, 1)',
            borderWidth: '0',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgba(133, 0, 27, 1)',
            padding: '10px 20px',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
    {
      id: 'bfq3',
      contentItems: [
        // (() => {
        //   const customImage = JSON.parse(JSON.stringify(image))
        //   customImage.content.url = 'https://assets.onvocado.com/templates/black_friday-tag_white-small.png'
        //   Object.assign(customImage.styling, {
        //     backgroundColor: 'rgba(0, 0, 0, 0)',
        //     backgroundSize: 'cover',
        //     backgroundPosition: 'center',
        //   })
        //   return customImage
        // })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '10px'
          return customSpacer
        })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'How satisfied are you with our promotions?'
          Object.assign(customHeadline.styling, {
            color: '#FFFFFF',
            fontSize: '26px',
            fontFamily: 'Anton',
            fontWeight: 'bold',
            textAlign: 'left',
          })
          return customHeadline
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '10px'
          return customSpacer
        })(),
        (() => {
          const customRank = JSON.parse(JSON.stringify(rank))
          customRank.settings.type = 'heart'
          customRank.settings.label = 'Satisfaction Rating'
          customRank.settings.required = true
          customRank.styling.baseColor = '#FEFEFE'
          customRank.settings.count = 10
          return customRank
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '15px'
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Next'
          Object.assign(customButton.styling, {
            color: '#FFFFFF',
            fontSize: '20px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            borderColor: 'rgba(133, 0, 27, 1)',
            borderWidth: '0',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgba(133, 0, 27, 1)',
            padding: '10px 20px',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = true
          return customButton
        })(),
      ],
    },
    {
      id: 'bfq4',
      contentItems: [
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '10px'
          return customSpacer
        })(),
        // (() => {
        //   const customImage = JSON.parse(JSON.stringify(image))
        //   customImage.content.url = 'https://assets.onvocado.com/templates/black_friday-tag_white-small.png'
        //   Object.assign(customImage.styling, {
        //     backgroundColor: 'rgba(0, 0, 0, 0)',
        //     backgroundSize: 'cover',
        //     backgroundPosition: 'center',
        //   })
        //   return customImage
        // })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'What is the biggest motivator for you to buy new things?'
          Object.assign(customHeadline.styling, {
            color: '#FFFFFF',
            fontSize: '26px',
            fontFamily: 'Anton',
            fontWeight: 'bold',
            textAlign: 'left',
          })
          return customHeadline
        })(),
        (() => {
          const customSurvey = JSON.parse(JSON.stringify(survey))
          customSurvey.content.options = [
            { id: 'k5rj2hy', text: 'Exclusive Discounts' },
            { id: '9sheias', text: 'Limited-Time Offers' },
            { id: '9sheias', text: 'New Product Releases' },
            { id: '9sheias', text: 'Beauty Products' },
          ]
          Object.assign(customSurvey.styling, {
            color: 'rgb(0, 0, 0)',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Anton',
            fontWeight: '400',
            borderColor: 'rgba(0, 0, 0, 1)',
            borderWidth: '0px',
            borderRadius: '20px',
            backgroundColor: 'rgb(254,254,254)',
          })
          customSurvey.settings.label = 'Shopping Motivation'
          customSurvey.settings.required = true
          return customSurvey
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '15px'
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Finish'
          Object.assign(customButton.styling, {
            color: '#FFFFFF',
            fontSize: '20px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            borderColor: 'rgba(133, 0, 27, 1)',
            borderWidth: '0',
            borderRadius: '5px',
            backgroundColor: 'rgba(133, 0, 27, 1)',
          })
          customButton.settings.action = 'next'
          customButton.settings.backBtn = true
          return customButton
        })(),
      ],
    },
    {
      id: 'bfq5',
      contentItems: [
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '10px'
          return customSpacer
        })(),
        // (() => {
        //   const customImage = JSON.parse(JSON.stringify(image))
        //   customImage.content.url = 'https://assets.onvocado.com/templates/black_friday-tag_white-small.png'
        //   Object.assign(customImage.styling, {
        //     backgroundColor: 'rgba(0, 0, 0, 0)',
        //     backgroundSize: 'cover',
        //     backgroundPosition: 'center',
        //   })
        //   return customImage
        // })(),
        (() => {
          const customHeadline = JSON.parse(JSON.stringify(headline))
          customHeadline.content.text = 'Thank You for Participating!'
          Object.assign(customHeadline.styling, {
            color: '#FFFFFF',
            fontSize: '32px',
            fontFamily: 'Anton',
            fontWeight: 'bold',
            textAlign: 'center',
          })
          return customHeadline
        })(),
        (() => {
          const customText = JSON.parse(JSON.stringify(text))
          customText.content.text = '<p>As a token of our appreciation, here\'s an exclusive discount just for you!</p>'
          Object.assign(customText.styling, {
            color: '#FFFFFF',
            fontSize: '20px',
            textAlign: 'center',
            fontFamily: 'Roboto',
            fontWeight: '400',
          })
          return customText
        })(),
        // voucher
        (() => {
          const customVoucher = JSON.parse(JSON.stringify(voucher))
          customVoucher.content.text = 'BF-THANKYOU'
          Object.assign(customVoucher.styling, {
            color: 'rgba(255, 255, 255, 1)',
            borderColor: 'rgba(255, 255, 255, 1)',
            borderRadius: '5px',
            fontSize: '26px',
            fontWeight: 'bold',
            textAlign: 'center',
            fontFamily: 'Inter',
          })
          return customVoucher
        })(),
        (() => {
          const customSpacer = JSON.parse(JSON.stringify(spacer))
          customSpacer.styling.padding = '20px'
          return customSpacer
        })(),
        (() => {
          const customButton = JSON.parse(JSON.stringify(button))
          customButton.content.text = 'Continue Shopping'
          Object.assign(customButton.styling, {
            color: '#FFFFFF',
            fontSize: '20px',
            fontFamily: 'Roboto',
            fontWeight: 'bold',
            borderColor: 'rgba(133, 0, 27, 1)',
            borderWidth: '0',
            borderRadius: '5px',
            justifyContent: 'center',
            backgroundColor: 'rgba(133, 0, 27, 1)',
            padding: '10px 20px',
          })
          customButton.settings.action = 'close'
          customButton.settings.backBtn = false
          return customButton
        })(),
      ],
    },
  ],
}

export { json, info }
